// extracted by mini-css-extract-plugin
export var container = "_cl-0";
export var icon = "_cl-1";
export var text = "_cl-2";